import {types} from './types';

const setGetCashiersProfileAction = (payload) => {
  return {
    type: types.SET_CASHIERS_PROFILE,
    payload
  }
}

export {
  setGetCashiersProfileAction
}